const Highlights = ({ highlights = [] }) => {
  if (!highlights.length) return null;

  return (
    <section className="max-w-7xl mx-auto p-4">
      <div className="bg-blue-50 rounded-xl p-6">
        <h2 className="text-lg font-semibold mb-4">
          Why you should consider this property?
        </h2>

        <div className="grid md:grid-cols-2 gap-4">
          {highlights.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-2 text-green-700 text-sm"
            >
              <span>✔</span>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Highlights;
